import { LOCAL__collection_delete } from '@/state/collection/entity/local_collection_delete';
import { local_user_task_delete } from '@/state/generation/user_task/entity/local_user_task_delete';
import { local_search_delete } from '@/state/search/local_search_delete';
import { store } from '@/state/store';
import { local_workspace_billing_balance_delete } from '@/state/workspace/billing/local_workspace_billing_balance_delete';
import { local_workspace_billing_subscriptions_delete } from '@/state/workspace/billing/local_workspace_billing_subscriptions_delete';
import { try_set_default_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { local_workspace_delete } from '../entity/local_workspace_delete';
import { local_workspace_transfer_ownership_proposal_delete } from '../ownership/local_workspace_transfer_ownership_proposal_delete';

//we should't delete workspaces itself, we deleting all related entities
export const on_workspaces_deleted = async (workspaces_ids_to_delete: string[]) => {
  /*
   * COLLECTIONS
   */
  let collection_ids = Array.from(store.getState().slice_collections.collections_map.values())
    .filter(item => workspaces_ids_to_delete.includes(item.workspace_id) && !item.is_shared)
    .map(item => item._id);
  store.dispatch(LOCAL__collection_delete(collection_ids));

  /*
   * USER TASK
   */

  let user_tasks_ids = Array.from(store.getState().slice_generation.user_tasks_map.values())
    .filter(item => workspaces_ids_to_delete.includes(item.workspace_id) && !item.is_shared)
    .map(item => item._id);

  store.dispatch(local_user_task_delete(user_tasks_ids));

  /*
   * SEARCH
   */

  let search_ids = Array.from(store.getState().slice_search.search_history_map.values())
    .filter(item => workspaces_ids_to_delete.includes(item.workspace_id) && !item.is_shared)
    .map(item => item._id);

  store.dispatch(local_search_delete(search_ids));

  /*
   * WORKSPACE BALANCE
   */

  let billing_balance_ids = Array.from(store.getState().slice_workspace_billing.balances_map.values())
    .filter(item => workspaces_ids_to_delete.includes(item._id))
    .map(item => item._id);

  store.dispatch(local_workspace_billing_balance_delete(billing_balance_ids));

  /*
   * WORKSPACE SUBSCRIPTION
   */

  let workspace_subscription_ids = Array.from(store.getState().slice_workspace_billing.subscriptions_map.values())
    .filter(item => item.workspace_id == item.workspace_id)
    .map(item => item._id);

  store.dispatch(local_workspace_billing_subscriptions_delete(workspace_subscription_ids));

  /*
   * WORKSPACE USERS
   */

  let workspace_user_ids = Array.from(store.getState().slice_workspace.all_workspaces_users_map.values())
    .flatMap(innerMap => Array.from(innerMap.values()))
    .filter(item => item.workspace_id == item.workspace_id)
    .map(item => item._id);

  store.dispatch(local_workspace_billing_subscriptions_delete(workspace_user_ids));

  /*
   * WORKSPACES TRANSFER OWNERSHIP PROPOSALS
   */

  let transfer_ownership_proposal_ids = Array.from(store.getState().slice_workspace.transfer_ownership_proposals_map.values())
    .filter(item => item.workspace_id == item.workspace_id)
    .map(item => item._id);

  store.dispatch(local_workspace_transfer_ownership_proposal_delete(transfer_ownership_proposal_ids));

  /*
   * WORKSPACES
   */

  store.dispatch(local_workspace_delete(workspaces_ids_to_delete));

  await try_set_default_workspace();
};
